export const VELOCITY_LOCAL_STORAGE_KEY = 'velocity';

/**
 * The key used to store the user's favorite items in the local storage.
 */
export const FAVORITES_LOCAL_STORAGE_KEY = 'favorites';

export const LOYALTY_LOCAL_STORAGE_KEY = 'loyalty';

export const MERGED_CART_LOCAL_STORAGE_KEY = 'dismissedMergedCartBanners';

export const AUTOSHIP_DISCOUNT_BANNER_LOCAL_STORAGE_KEY = 'autoshipDiscountBanner';

export const PROCEED_TO_CHECKOUT_PRESSED = 'proceedToCheckoutPressed';

export const WAS_LOGGED_USER_ADDRESS_CHANGED = 'wasLoggedUserAddressChanged';

export const CART_NOTIFICATIONS_STORAGE_KEY = 'cartNotificationsStorageKey';

export const CART_NOTIFICATIONS_SEEN_IDS_KEY = 'cartNotificationsSeenIds';

export const AUTOSHIP_CACHE_KEY = 'autoship_data_cache';

export const PDP_FINDING_METHOD_BY_SKU = 'pdpFindingMethodBySku';
